import React, { useEffect, useState } from 'react'

const style = {
    height:'180%',
    width:'100vw',
    position:'fixed',
    zIndex:'999',
    background:'transparent',
    top:'-80px'
}
function OutsideClick({arrowState,isMobile,handleOutsideClick}) {
    const [open, setOpen] = useState(arrowState||isMobile);
    useEffect(() => {
        if(arrowState){
            setOpen(true);
        }
        if(isMobile){
            setOpen(true);
        }
        if(!arrowState && !isMobile){
            setOpen(false);
        }
    },[arrowState,isMobile]);

    return open ? <div style={style} onClick={handleOutsideClick}/> : <div />;
}

export default React.memo(OutsideClick)